import firebase from 'firebase.js';
import Controller from './Controller';
import AgencyController from './AgencyController';
import PositionController from './PositionController';
import ActivationController from './ActivationController';

export default class ContactController extends Controller {
  constructor(collection, item, unique) {
    super(collection, item, unique);
    this.collection = 'contacts';
    this.item = 'contact';
  }

  fetch = () => {
    const act = new ActivationController();
    const pc = new PositionController();
    const ac = new AgencyController();
    return firebase
      .firestore()
      .collection('contacts')
      .get()
      .then((contactSnaps) => {
        if (contactSnaps.size > 0) {
          const promises = contactSnaps.docs.map(async (doc) => ({
            id: doc.id,
            ...doc.data(),
            activation: await act.fetchById(doc.data().activationId),
            agency: await ac.fetchById(doc.data().agenceId),
            position: await pc.fetchById(String(doc.data().positionId)),
          }));
          return Promise.all(promises);
        }
        return [];
      });
  };

  /**
   * Get Contact data
   * @param {string} agencyId Contact ID
   * @returns {Object} object of Contact data or false
   */
  fetchById = async (agencyId) =>
    agencyId
      ? this.getDoc(agencyId).then((contactSnap) => {
          if (contactSnap.exists) {
            return {
              id: contactSnap.id,
              ...contactSnap.data(),
            };
          }
          return null;
        })
      : null;
}
